var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "tls-faq" }, [
    _c("header", { staticClass: "tls-simple-banner" }, [
      _c("div", { staticClass: "tls-home-text-group" }, [
        _c("h1", { staticClass: "tls-heading-1" }, [
          _vm._v(_vm._s(_vm._.get(_vm.cmsData, "title")))
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "tls-simple-text -color-white -size-20" }, [
          _vm._v(_vm._s(_vm._.get(_vm.cmsData, "primary_sub_title")))
        ])
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "tls-static-content tls-faq-content" }, [
      _c("div", { staticClass: "tls-large-card-info" }, [
        _c("div", { staticClass: "tls-card-lg" }, [
          _c("div", { staticClass: "tls-simple-text -size-16" }, [
            _c("p", [_vm._v(_vm._s(_vm._.get(_vm.cmsData, "subtitle")))])
          ])
        ]),
        _vm._v(" "),
        _vm._m(0)
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "tls-faq-action", attrs: { id: "top" } }, [
        _c("div", { staticClass: "tls-faq-action--slot" }, [
          _c("h2", {
            directives: [
              {
                name: "dompurify-html",
                rawName: "v-dompurify-html",
                value: _vm._.get(_vm.cmsData, "card_title"),
                expression: "_.get(cmsData, 'card_title')"
              }
            ],
            staticClass: "tls-heading-2"
          })
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "tls-faq-action--slot" }, [
          _c("h2", { staticClass: "tls-heading-2" }, [
            _vm._v(_vm._s(_vm._.get(_vm.cmsData, "content_title")))
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "tls-faq-action--slot" }, [
          _c("div", {
            directives: [
              {
                name: "dompurify-html",
                rawName: "v-dompurify-html",
                value: _vm._.get(_vm.cmsData, "content"),
                expression: "_.get(cmsData, 'content')"
              }
            ],
            staticClass: "tls-faq-action-text"
          })
        ])
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "tls-large-card-info--decoration" }, [
      _c("div", { staticClass: "tls-decoration-vertical-lines -blue" }, [
        _c("div", { staticClass: "tls-line1" }),
        _vm._v(" "),
        _c("div", { staticClass: "tls-line2" })
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }